/** Directions for keyboard + single-pointer reorder (WCAG 2.5.7). */
export const PANEL_MOVE_DIRECTIONS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"] as const;
export type PanelMoveDirection = (typeof PANEL_MOVE_DIRECTIONS)[number];

export function isPanelMoveDirection(value: string): value is PanelMoveDirection {
    return (PANEL_MOVE_DIRECTIONS as readonly string[]).includes(value);
}
